const userLists = {
  userLists: 'Список користувачів адміністратора',
  showing: 'Показано',
  userListsOf: 'користувачі',
  noUserListsFound: 'Користувачів не знайдено',
  actionsDropdown: {
    details: 'Деталі',
    deactivate: 'Деактивувати',
    edit: 'Редагувати',
  },
  modal: {
    editUser: 'Редагувати користувача',
    name: "Ім'я",
    email: 'Електронна пошта',
    role: 'Роль',
    messengers: 'Посилання',
    priceplan: 'Ціновий план',
    manager: 'Менеджер',
    isAlive: 'Активний',
    emailVerified: 'Електронна пошта підтверджена',
    successUpdate: 'Зміни до даних користувача успішно застосовано.',
  },
  tableDropdown: {
    quickActions: 'Меню швидких дій',
    refresh: 'Оновити',
    exportUserList: 'Експорт',
    exportUserListCurrent: 'Експортувати поточний',
  }
};

export default userLists;
